import api from './api';
import { News, PaginatedResponse } from '../types';

export type NewsStatus = 'DRAFT' | 'PUBLISHED' | 'HIDDEN' | 'ARCHIVED';

interface NewsFilters {
  status?: NewsStatus;
  search?: string;
  templeId?: number;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export const newsService = {
  async getList(filters: NewsFilters = {}): Promise<PaginatedResponse<News>> {
    const params = new URLSearchParams();
    
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.templeId) params.append('templeId', filters.templeId.toString());
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    
    const response = await api.get<PaginatedResponse<News>>('/news', { params });
    return response.data;
  },

  async getById(id: number): Promise<News> {
    const response = await api.get<News>(`/news/${id}`);
    return response.data;
  },

  async getBySlug(slug: string): Promise<News> {
    const response = await api.get<News>(`/news/slug/${slug}`);
    return response.data;
  },

  async create(data: Omit<News, 'id' | 'createdAt' | 'updatedAt'>): Promise<News> {
    const response = await api.post<News>('/news', data);
    return response.data;
  },

  async update(id: number, data: Partial<News>): Promise<News> {
    const response = await api.put<News>(`/news/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/news/${id}`);
  },

  async publish(id: number): Promise<News> {
    const response = await api.post<News>(`/news/${id}/publish`);
    return response.data;
  },

  async unpublish(id: number): Promise<News> {
    const response = await api.post<News>(`/news/${id}/unpublish`);
    return response.data;
  },
};
